/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { FormattedRelative } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './District.css';
import { connect } from 'react-redux';

import { districtsWithGraveyards } from '../../constants';
import MapControl from '../../components/MapControl';

import {
  fetchSectors,
  fetchGraveyard,
  fetchZarzad,
  fetchGraves,
  fetDistrictCompositions,
  fetchDistrictParcels,
} from '../../actions/district';

class District extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  componentDidMount() {
    if (districtsWithGraveyards.includes(this.props.district.prefix)) {
      this.props.fetchSectors(this.props.district.prefix);
      this.props.fetchGraves(this.props.district.prefix);
      this.props.fetchGraveyard(this.props.district.prefix);
      this.props.fetchZarzad(this.props.district.prefix);
    } else {
      this.props.fetchDistrictParcels();
    }
    this.props.fetDistrictCompositions();
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.mymap}>{this.props.district ? <MapControl /> : null}</div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
});
const mapDispatch = {
  fetchSectors,
  fetchGraveyard,
  fetchGraves,
  fetDistrictCompositions,
  fetchDistrictParcels,
  fetchZarzad
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(District),
);



// WEBPACK FOOTER //
// src/routes/district/District.js